import axios from "axios";

const BASE_URL = "https://hrmsnew.prepstripe.com/api";

export const registerUser = async (data) => {
  try {
    const response = await axios.post(`${BASE_URL}/register`, data);
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};
export const loginUser = async (data) => {
  try {
    const response = await axios.post(`${BASE_URL}/login`, data);
    await new Promise((r) => setTimeout(r, 1000));
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};
// Logout user
export const logoutUser = async (token, userId) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/logout`, // Use the correct endpoint for logout
      { user_id: userId }, // Include user_id if required
      {
        headers: {
          Authorization: `Bearer ${token}`, // Attach the Bearer token in headers
        },
      },
    );
    // console.log("Logout response:", response.data); // Log the response for debugging
    return {
      message: response.data.message || "Logout successful.",
      success: true,
    };
  } catch (error) {
    return {
      message: error.response?.data?.message || "Logout failed.",
      success: false,
    };
    // throw error.response?.data || { message: "An error occurred during logout." };
  }
};

// Fetch user roles and permissions
export const fetchUserDetails = async (token) => {
  try {
    const response = await axios.get(`${BASE_URL}/me`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    throw error.response.data;
  }
};
